exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a-product-quantity[data-v-73e8e2d2]{display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;height:auto;width:100%;min-width:4.625rem;max-width:5.625rem}\n", ""]);

// exports
